/**
 * Service for validating and formatting strata plan numbers
 */
export class StrataPlanNumberValidationService {
    /**
     * Validates and formats a strata plan number
     * @param strataPlanNumber The potential strata plan number to validate
     * @returns Object containing the formatted strata plan number (if valid) and validity flag
     */
    validateStrataPlan(strataPlanNumber) {
        if (!strataPlanNumber) {
            return {
                formattedStrataPlanNumber: null,
                isValid: false,
            };
        }
        try {
            // Check if original input contains special characters
            if (this.containsSpecialCharacters(strataPlanNumber)) {
                return {
                    formattedStrataPlanNumber: null,
                    isValid: false,
                };
            }
            // Clean the input string
            const cleaned = this.cleanStrataPlanInput(strataPlanNumber);
            // Regular expression to match strata plan pattern: letters followed by numbers
            // Common prefixes include LMS, VAS, EPS, etc.
            const strataPlanRegex = /^([A-Za-z]+)[\s-]?(\d+)$/;
            const match = cleaned.match(strataPlanRegex);
            if (!match) {
                return {
                    formattedStrataPlanNumber: null,
                    isValid: false,
                };
            }
            const [, prefix, number] = match;
            // Format consistently as "PREFIX NUMBER" (e.g., "VAS 2844")
            const formattedStrataPlanNumber = `${prefix.toUpperCase()} ${number}`;
            return {
                formattedStrataPlanNumber,
                isValid: true,
            };
        }
        catch (error) {
            return {
                formattedStrataPlanNumber: null,
                isValid: false,
            };
        }
    }
    /**
     * Checks if the input contains any special characters not allowed in strata plan numbers
     * @param input The input string to check
     * @returns True if special characters are found
     */
    containsSpecialCharacters(input) {
        // Check for any characters that are not alphanumeric, spaces, or hyphens
        const specialCharPattern = /[^\w\s-]/;
        return specialCharPattern.test(input);
    }
    /**
     * Cleans the input strata plan string by removing unnecessary characters
     * @param input The raw strata plan input
     * @returns Cleaned strata plan string
     */
    cleanStrataPlanInput(input) {
        // Remove extra whitespace and trim
        let cleaned = input.trim().replace(/\s+/g, " ");
        // Remove hyphens and replace with spaces
        cleaned = cleaned.replace(/-/g, " ");
        return cleaned;
    }
}
//# sourceMappingURL=StrataPlanNumberValidationService.js.map